import { createTheme } from '@mui/material/styles';
import { BaseMuiThemeComponentsSettings } from './toolympus/components/primitives/BaseThemeSettings';

export const ThemeSettings = {
  colors: {
    primary: "#F17030",
    background: "#2A2624", // default brown
    backgroundAlt: "#35312E", // lighter brown
    backgroundDark: "#22201E",
    backgroundExtraLight: "#464341",
    text: "#E2E2E2",
  }
}


export const theme = createTheme({
    palette: {
        primary: {
            main: ThemeSettings.colors.primary,
        },
        secondary: {
            main: ThemeSettings.colors.backgroundExtraLight,
        },
    },

    components: {
      ...BaseMuiThemeComponentsSettings,
    },
});
